import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f72c6c1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "week-selector-content" }
const _hoisted_3 = { class: "buttons-container" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("保存")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_switch = _resolveComponent("van-switch")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_van_skeleton = _resolveComponent("van-skeleton")!
  const _component_van_checkbox = _resolveComponent("van-checkbox")!
  const _component_van_checkbox_group = _resolveComponent("van-checkbox-group")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_action_sheet = _resolveComponent("van-action-sheet")!
  const _component_van_picker = _resolveComponent("van-picker")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_van_nav_bar, {
      title: "定时上下线",
      "left-text": "返回",
      "left-arrow": "",
      onClickLeft: _ctx.goBack
    }, null, 8, ["onClickLeft"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_van_skeleton, {
        row: 3,
        loading: _ctx.loading
      }, {
        default: _withCtx(() => [
          _createVNode(_component_van_cell_group, null, {
            default: _withCtx(() => [
              _createVNode(_component_van_cell, {
                center: "",
                title: "星期",
                "is-link": "",
                value: _ctx.weekSelectText,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showWeekSelector = true))
              }, null, 8, ["value"]),
              _createVNode(_component_van_cell, {
                center: "",
                title: "定时上线",
                label: "开启后，账号将在设定时间内自动上线"
              }, {
                "right-icon": _withCtx(() => [
                  _createVNode(_component_van_switch, {
                    modelValue: _ctx.autoOnline,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.autoOnline) = $event)),
                    onChange: _ctx.save,
                    size: "24"
                  }, null, 8, ["modelValue", "onChange"])
                ]),
                _: 1
              }),
              (_ctx.autoOnline)
                ? (_openBlock(), _createBlock(_component_van_cell, {
                    key: 0,
                    center: "",
                    title: "上线时间",
                    "is-link": "",
                    value: _ctx.onlineTimeText,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.displayRangePopup('online')))
                  }, null, 8, ["value"]))
                : _createCommentVNode("", true),
              _createVNode(_component_van_cell, {
                center: "",
                title: "定时下线",
                label: "开启后，账号将在设定时间内自动下线"
              }, {
                "right-icon": _withCtx(() => [
                  _createVNode(_component_van_switch, {
                    modelValue: _ctx.autoOffline,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.autoOffline) = $event)),
                    onChange: _ctx.save,
                    size: "24"
                  }, null, 8, ["modelValue", "onChange"])
                ]),
                _: 1
              }),
              (_ctx.autoOffline)
                ? (_openBlock(), _createBlock(_component_van_cell, {
                    key: 1,
                    center: "",
                    title: "下线时间",
                    "is-link": "",
                    value: _ctx.offlineTimeText,
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.displayRangePopup('offline')))
                  }, null, 8, ["value"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["loading"])
    ]),
    _createVNode(_component_van_action_sheet, {
      show: _ctx.showWeekSelector,
      "close-on-click-overlay": true,
      closeable: false,
      title: "选择日期"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_van_checkbox_group, {
            modelValue: _ctx.weekSelect,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.weekSelect) = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_van_cell_group, { inset: "" }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weekSelectsMap, (day, index) => {
                    return (_openBlock(), _createBlock(_component_van_cell, {
                      clickable: "",
                      key: day.key,
                      title: day.value,
                      onClick: ($event: any) => (_ctx.toggle(index))
                    }, {
                      "right-icon": _withCtx(() => [
                        _createVNode(_component_van_checkbox, {
                          name: day.key,
                          ref: (el) => (_ctx.checkboxRefs[index] = el),
                          onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
                        }, null, 8, ["name"])
                      ]),
                      _: 2
                    }, 1032, ["title", "onClick"]))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_van_button, {
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showWeekSelector = false))
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }),
            _createVNode(_component_van_button, {
              onClick: _ctx.saveWeekSelector,
              type: "primary"
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_popup, {
      show: _ctx.showRangePopup,
      "onUpdate:show": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.showRangePopup) = $event)),
      round: "",
      position: "bottom"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_picker, {
          columns: _ctx.rangePopupColumns,
          onCancel: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showRangePopup = false)),
          onConfirm: _ctx.confirmPopup
        }, null, 8, ["columns", "onConfirm"])
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}